import { Serv_send } from './Serv.socketClient'
import type { Sync_Params } from '../Sync/Sync.standardSync'
import type { UsersSyncProfileOutput } from '../../../shared/domain/users/types.no-deps'

export async function Serv_syncUserProfiles(params: Sync_Params) {
    // The auth server's a bit pedantic about the difference between being modified at a date and never being modified
    // so it won't send us any accounts that have never been changed if we pass it a date instead of null.
    const lastSyncTime = params.lastSyncTime.getTime() === 0 ? null : params.lastSyncTime.toISOString()
    const response = (await Serv_send('user.syncProfiles', { lastSyncTime })) as UsersSyncProfileOutput

    // Pass back teams unchanged even though endpoint doesn't currently use it just
    // so we have a consistent API with other sync endpoints
    const teams = params.teams

    return { ...response, syncTime: new Date(response.syncTime), teams, deletedProfiles: response.deletedProfiles }
}
